import { useEffect, useState } from "react";
import { axiosPrivate } from "../../utils/axios";
import useAuth from "../../hooks/useAuth";
import { tr } from "date-fns/locale";
import Swal from "sweetalert2";
import { useFormState } from "react-dom";
import axios from "axios";
import { ReactComponent as Delete } from "../../assets/images/svg/Delete.svg";
import { useAsyncError } from "react-router-dom";



function CallType(props) {
  console.log("<<<<<<<<<", props, "?????????????");

  // user id //
  const user = useAuth();
  const { auth } = useAuth;
  const user_id = user.auth.user_details.id;

  const isValidCustomerRatio = (value) =>
    /^[0-9]+$/.test(String(value)) && Number(value) >= 1 && Number(value) <= 3;

  const sendCallTypeToNewCampaign = () => {
    if (props.callType === "") {
      Swal.fire({
        icon: "error",
        title: "Campaign Creation Failed",
        text: "Please select a Call Type for the campaign.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      })
      return;
    }

    if (props.predictiveDialer && !isValidCustomerRatio(props.customer_ratio)) {
      Swal.fire({
        icon: "error",
        title: "Campaign Creation Failed",
        text: "Please provide a valid Customer ratio (a whole number from 1 to 3) for the campaign.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      })
      return;
    }

    props.setActive(props.next);
  };
  const [voicebottemplates, setVoiceBotTemplates] = useState([])

  const fetchVoiceBotTemplates = async () => {
    const controller = new AbortController();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}/contactcentre/voice_templates/`,
        {
          signal: controller.signal,
          params: {
            user_id: user_id,
          },
        }
      );
      setVoiceBotTemplates(response.data);
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Failed to fetch voice bot templates", error);
      }
    }
  };

  const [intervalValue, setIntervalValue] = useState(0)

  useEffect(() => {
    console.log(props.retry_schedule_data?.length, '+================', props.retry_schedule_data)
    if (props.retry_schedule_data == undefined) {
      return;
    }
    if (props.retry_schedule_data?.length !== 0) {
      if (props.retry_time_gap === 'Fixed') {
        props.setData((oldArray) => ({
          ...oldArray,
          retry_interval_value: props.retry_schedule_data?.[0]?.interval_value
        }));
      }
      setRetry(true);
    } else {
      setRetry(false);
    }


  }, [])

  useEffect(() => {
    if (props.retry_schedule_data == undefined) {
      return;
    }
    if (props.retry_schedule_data?.length !== 0) {
      if (props.retry_time_gap === 'Fixed') {
        props.setData((oldArray) => ({
          ...oldArray,
          retry_interval_value: props.retry_schedule_data?.[0]?.interval_value
        }));
      }
      setRetry(true);
    } else {
      setRetry(false);
    }

  
  },[])

  useEffect(() => {
    if (props.callType == "voice-bot") {
      fetchVoiceBotTemplates();
    }
    if (props.retry_type) {
      setRetry(true);
    }

    const retryIntervals = Array.from({ length: props.maxRetry }, (_, index) => ({
      id: null,
      retry: index + 1,
      interval_type: "Minutes",
      interval_value: intervalValue,
    }));
    setRetryIntervalData(props.retry_schedule_data);
    console.log("retry_schedule_data   ", props.retry_schedule_data)
    console.log("--------------------", retry_interval_data, "----------------")
  }, [])

  const [retry_interval_data, setRetryIntervalData] = useState(props.retry_schedule_data);

  useEffect(() => {
    props.setData((oldArray) => {
      return { ...oldArray, retry_schedule_data: retry_interval_data };
    });
  }, [retry_interval_data,])

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    props.setData((oldArray) => {
      const baseData = { ...oldArray, call_type: selectedValue };

      if (selectedValue !== oldArray.call_type) {
        setRetry(false);
        setRetryIntervalData([]);

        return {
          ...baseData,
          maxRetry: 0,
          progressiveDialer: false,
          predictiveDialer: false,
          customer_ratio: "",
          voice_boat_template: "",
          voice_bot_call_limit: 1,
          retry_type: "",
          retry_interval_value: "",
          retry_time_gap: "Fixed",
          retry_schedule_data: [],
          call_type: selectedValue,
        };
      }

      return baseData;
    });

    if (selectedValue === "voice-bot") {
      fetchVoiceBotTemplates();
    }
  };

  //  Customer Phone Number Masking Permission //
  const [isChecked, setIsChecked] = useState(false);

  const handelcustomerNumberMaskingPermission = (event) => {
    setIsChecked(event.target.checked);
    props.setData((oldArray) => {
      return { ...oldArray, customerNumberMask: event.target.checked };
    });
  };

  const handleCallIntervalTimeTimeChange = (event) => {
    props.setData((oldArray) => {
      return { ...oldArray, campaignStartTime: event.target.value };
    });
  };

  const handleNextCallIntervalTimeTimeChange = (event) => {
    props.setData((oldArray) => {
      return { ...oldArray, nextCallTime: event.target.value };
    });
  };

  const handleMaximumRetryChange = (event) => {
    const maxRetry =
      typeof event === "number"
        ? event
        : Number(event?.target?.value ?? 0);

    props.setData((oldArray) => {
      return { ...oldArray, maxRetry: maxRetry };
    });

    const retryIntervals = Array.from({ length: maxRetry }, (_, index) => ({
      id: null,
      retry: index + 1,
      interval_type: "Minutes",
      interval_value: intervalValue,
    }));
    setRetryIntervalData(retryIntervals);
  };

  const handleProgressiveChange = () => {
    if (props.progressiveDialer == true) {
      setRetry(false)
      props.setData((old) => ({
        ...old,
        progressiveDialer: false,
        predictiveDialer: false,
        did: null,
      }));
    } else {
      setRetry(true)
      props.setData((old) => ({
        ...old,
        progressiveDialer: true,
        predictiveDialer: false,
        did: null,
      }));
    }
  };

  const handlePredictiveChange = () => {
    if (props.predictiveDialer == true) {
      props.setData((old) => ({
        ...old,
        progressiveDialer: false,
        predictiveDialer: false,
        did: null,
      }));
    } else {
      // Check predictive, uncheck progressive
      props.setData((old) => ({
        ...old,
        progressiveDialer: false,
        predictiveDialer: true,
        did: null,
      }));
    }
  };

  const handleCustomerRatio = (event) => {
    props.setData((oldArray) => {
      return { ...oldArray, customer_ratio: event.target.value };
    });
  }

  const handleCallLimit = (event) => {
    props.setData((oldArray) => {
      return { ...oldArray, voice_bot_call_limit: event.target.value };
    });
  }

  const selectTemplate = (event) => {
    props.setData((oldArray) => {
      return { ...oldArray, voice_boat_template: event.target.value };
    });
  }

  const selectRetryType = (event) => {
    const value = event?.target?.value
    props.setData((oldArray) => {
      return { ...oldArray, retry_type: value };
    });
  }

  const selectRetryMinutes = (eventOrValue) => {
    const value = typeof eventOrValue === "object"
      ? eventOrValue?.target?.value
      : eventOrValue;

    props.setData((oldData) => ({
      ...oldData,
      retry_interval_value: value,
    }));
    const updatedData = retry_interval_data.map(item => ({
      ...item,
      interval_value: value
    }));

    setRetryIntervalData(updatedData);
  };
  const [timegap, setTimeGap] = useState("Fixed")
  const [retry, setRetry] = useState(false)
  const handelRetry = (event) => {
    setRetry(event.target.checked);

  }

  const selectTimeGap = (event) => {
    props.setData((oldArray) => {
      setTimeGap(event.target.value)
      return { ...oldArray, retry_time_gap: event.target.value }
    })

  }

  const handleRetryChange = (index, field, value) => {
    setRetryIntervalData((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const DeleteRetryRow = async (index, id) => {
    if (id != null) {
      Swal.fire({
        title: "Are you sure to Delete ?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let config = {
            headers: { "Content-Type": "application/json" },
            data: {
              "retry_schedule_id": id,
            }
          };
          await axios
            .delete(
              process.env.REACT_APP_API_URL + "/contactcentre/delete-retry-schedule/",
              config
            )
            .then((res) => {
              Swal.fire(
                'Deleted!',
                'Retry schedule has been deleted.',
                'success'
              );
            })
        }
      })
    }
    props.setData(prev => ({
      ...prev,
      retry_schedule_data: prev.retry_schedule_data.filter(
        (_, i) => i !== index
      )
    }));

    setRetryIntervalData((prev) =>
      prev.filter((item) => item.id !== id)
    );

  };

  const [templates, setTemplates] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [template_name, setTemplateName] = useState("")
  const [template, setTemplate] = useState(false);


  useEffect(() => {
    setTimeGap(props.retry_time_gap)
    if (!user_id) return;

    const fetchTemplates = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/contactcentre/retry_templates/`,
          {
            params: { user_id },
          }
        );

        setTemplates(data.data || []);
      } catch (err) {
        console.error("Failed to fetch templates:", err);
      }
    };

    fetchTemplates();
  }, [retry, user_id]);


  const [currentTemplate, setCurrentTemplate] = useState("")
  const getTemplateData = async (e) => {
    const template_id = e.target.value;

    // Reset previous template data first
    setSelectedTemplate("");
    setRetryIntervalData([]);
    setTimeGap("Fixed");
    props.setData((old) => ({
      ...old,
      maxRetry: 0,
      retry_interval_value: "",
      retry_time_gap: "",
      retry_schedule_data: [],
    }));

    if (template_id === "") return; // user selected empty option — stop here

    setSelectedTemplate(template_id);

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/contactcentre/get_template_data/`,
      { params: { template_id } }
    );
    setTemplate(true);
    setCurrentTemplate(data?.template_id)
    setTemplateName(data?.template_name)
    handleMaximumRetryChange(data.count);

    const time_gap = data.time_gap;
    setTimeGap(time_gap);
    props.setData((old) => ({ ...old, retry_time_gap: time_gap }));

    if (data.time_gap === "Fixed") {
      selectRetryMinutes(data.retry_interval_value);
    }

    setRetryIntervalData(data.data);
  };

  const RetryTemplate = (event) => {
    setTemplate(event.target.checked);
    console.log(template)
  }

  const CreateTemplate = async () => {

    if (retry_interval_data.some(item => Number(item.interval_value) === 0)) {
      Swal.fire({
        icon: "warning",
        title: "Error",
        text: "Please provide value"
      });
      return;
    }

    console.log("retry_interval_data    :  ", retry_interval_data)
    if (retry_interval_data.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please add retry schedules .",
      });
      return
    }

    if (template_name == "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Template name required"
      });
      return
    }

    let post_data = {
      "user": user_id,
      "template_name": template_name,
      "data": retry_interval_data,
      "time_gap": props.retry_time_gap || "Variable"
    }

    let config = {
      headers: { "Content-Type": "application/json" },
    };

    await axios
      .post(
        process.env.REACT_APP_API_URL + "/contactcentre/create_retry_template/",
        post_data,
        config
      )
      .then(() => {
        Swal.fire(
          "Created!",
          "Template Created.",
          "success"
        );
      });
  }

  const DeleteTemplate = async () => {
    if (currentTemplate != "") {
      let config = {
        headers: { "Content-Type": "application/json" },
      };
      await axios
        .post(
          process.env.REACT_APP_API_URL + "/contactcentre/delete_retry_template/",
          { "template_id": currentTemplate },
          config
        )
        .then(() => {
          Swal.fire(
            "Deleted!",
            "Template Deleted.",
            "success"
          );
        });
    } else {
      Swal.fire(
        "Warning!",
        "Please choose a template to delete",
      );
    }
  }

  return (
    <div className="max-w-5xl p-6 ml-5">
      <p className="text-sm text-slate-400">Step 4/7</p>
      <h1 className="text-lg font-bold">Let's Select Call Type</h1>
      <p className="text-sm text-slate-400 border-b-2 pb-8">
        Please select type, so that we can create new campaign
      </p>
      <div className="relative w-full flex space-x-2">
        <div className="w-[15rem]">
          <h1 className="text-md text-slate-400 pt-8">Call Type</h1>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
            value={props.callType}
            onChange={handleChange}
          >
            <option></option>
            <option value={"auto"}>Auto</option>
            <option value={"manual"}>Manual</option>
            <option value={"voice-bot"}>Voice Bot</option>
          </select>
        </div>
        {props.callType == "voice-bot" ? (<div></div>) : (
          <div className="w-[15rem]">
            <h1 className="text-md text-slate-400 pt-8">Call start time</h1>
            <input
              type="text"
              id="campaign_time_interval"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              placeholder="Campaign Start Time"
              onChange={handleCallIntervalTimeTimeChange}
              value={props.campaignStartTime}
              required
            />
          </div>
        )}
        {props.predictiveDialer ? (
          <div className="w-[15rem]">
            <h1 className="text-md text-slate-400 pt-8">Customer ratio</h1>
            <input
              type="number"
              id="customer_ratio"
              min="1"
              max="3"
              step="1"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              placeholder="Customer Ratio"
              onChange={handleCustomerRatio}
              value={props.customer_ratio}
              required
            />
            {Number(props.customer_ratio) > 3 ? (
              <p className="text-xs text-yellow-600 mt-1">
                Warning: Customer ratio should not exceed 3.
              </p>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <div></div>
        )}
        {props.callType === "voice-bot" ? (
          <div className="flex space-x-5">
            <div className="w-[15rem]">
              <h1 className="text-md text-slate-400 pt-8">Voice Bot Templates</h1>
              <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
                value={props.voice_boat_template}
                onChange={selectTemplate}
              >
                <option value="">Select template</option>
                {voicebottemplates.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.template_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-[5rem]">
              <h1 className="text-md text-slate-400 pt-8">Call Limit</h1>
              <input
                type="text"
                id="call_limit"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                placeholder="Call Limit"
                onChange={handleCallLimit}
                value={props.voice_bot_call_limit}
                required
              />
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className="w-[15rem]">
          <h1 className="text-md text-slate-400 pt-8">Next call interval</h1>
          <input
            type="text"
            id="next_call_time_Interval"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            placeholder="Next Call Start Interval"
            onChange={handleNextCallIntervalTimeTimeChange}
            value={props.nextCallTime}
            required
          />
        </div>

      </div>

      {/* Voice bot settings  */}
      {props.callType === "voice-bot" || props.progressiveDialer || props.predictiveDialer ? (
        <div className="flex space-x-4 pt-8">
          <div className="flex space-x-6 items-center">
            <label className="text-md text-slate-400">Enable Retry For Not Answered Leads : </label>
            <input
              id="default-checkbox"
              type="checkbox"
              value=""
              checked={retry}
              onChange={handelRetry}
              className="w-6 h-6 border border-default-medium rounded-xs bg-neutral-secondary-medium"
            />
          </div>
        </div>
      ) : (
        <div></div>
      )}
      {retry ? (
        <div className="flex space-x-5 items-center pt-8">
          <h1 className="text-md text-slate-400">Maximum Retry Attempts : </h1>
          <div className="w-[10rem]">
            <input
              type="text"
              id="maximum_retry_calls"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              placeholder="Attempt Count"
              onChange={handleMaximumRetryChange}
              value={props.maxRetry}
              required
            />
          </div>
          <h1 className="text-md text-slate-400">Time Gap :</h1>
          <div className="w-[8rem]">
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
              value={props.retry_time_gap}
              onChange={selectTimeGap}
            >
              <option value="Fixed">Fixed</option>
              <option value="Variable">Variable</option>
            </select>
          </div>
        </div>
      ) : (<div></div>)}

      {props.retry_time_gap == "Fixed" && retry ? (
        <div className="flex space-x-5 items-center pt-8">
          <label className="text-md text-slate-400">Minimum Time Gap Between Successive Retries : </label>
          <div className="w-[10rem]">
            <input
              type="text"
              id="retry_date"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              placeholder="Interval"
              onChange={selectRetryMinutes}
              value={props.retry_interval_value}
              required
            />
          </div>
          <div className="w-[8rem]">
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
              value={props.retry_type}
              onChange={selectRetryType}
            >
              <option value="Minutes">Minutes</option>
              <option value="Day">Days</option>
            </select>
          </div>
        </div>
      ) : (<div></div>)}


      <div className="flex space-x-6 mb-2 mt-2">
        <h1 className="text-md text-slate-400">Customer Number Masking</h1>
        <input
          id="checkbox"
          type="checkbox"
          checked={props.customerNumberMask}
          onChange={handelcustomerNumberMaskingPermission}
          className="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 rounded-md focus:ring-blue-500 focus:ring-2  "
        />
      </div>
      {props.callType === "auto" ? (
        <div className="w-15[rem]">
          <div className="flex justify-between space-x-6 w-[15rem] mb-2">
            <h1 className="text-md text-slate-400">Progressive Dialer</h1>
            <input
              id="default-checkbox"
              type="checkbox"
              checked={props.progressiveDialer}
              onChange={handleProgressiveChange}
              className="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2  "
            />
          </div>
          <div className="flex justify-between space-x-6 w-[15rem] mb-2">
            <h1 className="text-md text-slate-400">Predictive Dialer</h1>
            <input
              id="default-checkbox"
              type="checkbox"
              checked={props.predictiveDialer}
              onChange={handlePredictiveChange}
              className="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500   focus:ring-2  "
            />
          </div>
        </div>
      ) : (
        <div></div>
      )}

      {/* Retry Template Create  */}
      {retry ?
        <div className="flex items-center gap-6 mb-4 mt-4 flex-wrap">
          {/* Create Template Toggle */}
          <div className="flex items-center gap-3">
            <label className="text-md text-slate-400">
              Create Template
            </label>
            <input
              type="checkbox"
              checked={template}
              onChange={RetryTemplate}
              className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            />
          </div>


          {/* Template Name + Input */}
          {template ?
            <div className="flex items-center gap-3">
              <label className="text-md text-slate-400">
                Template Name
              </label>
              <input
                type="text"
                className="w-60 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2"
                placeholder="Enter template name"
                value={template_name}
                onChange={(e) => setTemplateName(e.target.value)}
                required
              />
            </div>
            : <></>}
          {/* Button */}
          {template ?
            <div className="flex space-x-5">
              <button
                type="button"
                className="ml-2 text-white bg-green-600 hover:bg-green-700 focus:ring-4 focus:ring-green-300 shadow-sm font-medium rounded-md text-sm px-5 py-2.5 transition duration-200"
                onClick={CreateTemplate}
              >
                Create
              </button>
              {currentTemplate ?
                <button
                  type="button"
                  className="ml-2 text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-green-300 shadow-sm font-medium rounded-md text-sm px-5 py-2.5 transition duration-200"
                  onClick={DeleteTemplate}
                >
                  Delete
                </button>
                : <></>}
            </div>
            : <></>}
        </div>
        : <></>}
      {/* End Template Create  */}

      {retry ?
        <div className="w-[15rem]">
          <h1 className="text-md text-slate-400 pt-8">Templates</h1>

          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5"
            value={selectedTemplate}
            onChange={getTemplateData}
          >
            <option value="">Select Template</option>

            {templates.map((temp) => (
              <option key={temp.id} value={temp.id}>
                {temp.template_name}
              </option>
            ))}

          </select>
        </div>
        : <></>}

      {props.retry_time_gap == "Variable" ? (
        <div>
          <div className="relative overflow-x-auto mt-12">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-2 font-medium text-gray-700">Retry Attempts</th>
                  <th className="px-4 py-2 font-medium text-gray-700">Interval</th>
                  <th className="px-4 py-2 font-medium text-gray-700">Day/Minutes</th>
                  <th className="px-4 py-2 font-medium text-gray-700">Action</th>
                </tr>
              </thead>
              <tbody>
                {retry_interval_data.map((obj, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-2 text-gray-700 font-mono">
                      {obj.retry}
                    </td>
                    <td className="px-4 py-2">
                      <div className="w-[5rem]">
                        <select
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[8rem] p-2.5 "
                          value={obj.interval_type}
                          onChange={(e) =>
                            handleRetryChange(index, "interval_type", e.target.value)
                          }
                        >
                          <option value="Minutes">Minutes</option>
                          <option value="Day">Days</option>
                        </select>
                      </div>
                    </td>
                    <td className="px-4 py-2">
                      <div className="w-[5rem]">
                        <input
                          type="text"
                          id="retry_date"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          placeholder="Interval"
                          value={obj.interval_value}
                          onChange={(e) =>
                            handleRetryChange(index, "interval_value", e.target.value)
                          }
                          required
                        />
                      </div>
                    </td>
                    <td className="px-4 py-2">
                      {obj.id != null ?
                        <button
                          onClick={() => DeleteRetryRow(index, obj.id)}
                          className="inline-flex items-center justify-center w-8 h-8 rounded-full text-red-500 hover:bg-red-50 hover:text-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-200"
                          aria-label={`Delete schedule ${obj}`}
                          title="Delete schedule"
                        >
                          <Delete
                            className="w-4 h-4"
                            fill="#b30000ff"
                            style={{ color: '#b30000ff' }}
                          />
                        </button>
                        : <></>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (<div></div>)}

      <div className="pt-8 flex justify-between items-between">
        <button
          className="px-8 py-3 font-semibold text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          onClick={() => {
            props.setActive(props.back);
          }}
        >
          Back
        </button>
        <button
          className="font-bold text-lg rounded-full w-36 h-12"
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
            color: "white",
          }}
          onClick={sendCallTypeToNewCampaign}
        >
          Next Step
        </button>
      </div>
    </div>
  );
}
export default CallType;
